import React, { useEffect, useState } from 'react';
import { Table, Descriptions } from 'antd';
import Promise from 'bluebird';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { selectors } from 'stores';
import { firebase } from '../../../lib/Firebase';

const ProcessingTab = () => {
  const products = useSelector(selectors.getProducts());
  const influencers = useSelector(selectors.getInfluencers());

  const [fetching, setFetching] = useState(false);
  const [data, setData] = useState([]);
  const columns = [
    {
      key: 'influencerUID',
      dataIndex: 'username',
      title: 'Username',
    },
    {
      key: 'productUID',
      dataIndex: 'productName',
      title: 'Product Name',
    },
  ];

  const expandedRow = ({ productName, username, completedAt }) => (
    <div className="partnership-details">
      <Descriptions title="Partnership" bordered>
        <Descriptions.Item label="Product">{productName}</Descriptions.Item>
        <Descriptions.Item label="Influencer">{username}</Descriptions.Item>
        <Descriptions.Item label="Completed At">
          {completedAt && moment.unix(completedAt).format('MMM DD, YYYY')}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );

  async function fetchData() {
    setFetching(true);
    const partnershipsSnap = await firebase.firestore
      .collection('influencersPartnerships')
      .where('payoutStatus', '==', 'processing')
      .get();

    const newState = await Promise.map(partnershipsSnap.docs, async doc => {
      const { influencerUID, productUID } = doc.data();
      let influencer = influencers[influencerUID];
      if (!influencers[influencerUID]) {
        influencer = (await firebase.firestore
          .collection('influencers')
          .doc(influencerUID)
          .get()).data();
      }

      let product = products[productUID];
      if (!products[productUID]) {
        product = (await firebase.firestore
          .collection('products')
          .doc(productUID)
          .get()).data();
      }

      const { name } = product;
      const { username } = influencer;

      return {
        key: doc.id,
        uid: doc.id,
        username,
        productName: name,
        ...doc.data(),
      };
    });

    setData([...data, ...newState]);
    setFetching(false);
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div id="denied-tab">
      <Table
        dataSource={data}
        columns={columns}
        expandedRowRender={expandedRow}
        pagination={false}
        loading={fetching}
      />
    </div>
  );
};

export default ProcessingTab;
